'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _core = require('@material-ui/core');

var _propTypes = _interopRequireDefault(require('prop-types'));

var _reactAdmin = require('react-admin');

var _ChevronLeft = _interopRequireDefault(
  require('@material-ui/icons/ChevronLeft')
);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * This component is used as the `title` prop of `Create`, `Edit`,
 * `Show` to include the Go Back button beside the title
 * Note that You have to specify the `basePath` so that the back button can work properly
 *
 * @example
 *
 *  const VehicleShow = (props) => {
 *    const { basePath } = props;
 *    return (
 *      <Show
 *        title={<TitleWithBackButton basePath={basePath}>Vehicle Details</TitleWithBackButton>}
 *        {...props}
 *      >
 *        <VehicleDetail />
 *      </Show>
 *    );
 *  };
 *
 * @typedef {Object} Props
 * @prop {ReactElement[]} children The title, or whatever
 * @prop {string} basePath The basePath
 *
 * @param {Prop} props
 */
var TitleWithBackButton = function TitleWithBackButton(_ref) {
  var children = _ref.children,
    basePath = _ref.basePath;
  return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_core.Box, {
    display: 'flex',
    alignItems: 'center',
    children: [
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
        component: _reactAdmin.ListButton,
        variant: 'outlined',
        color: 'primary',
        size: 'medium',
        label: 'ra.action.back',
        basePath: basePath,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ChevronLeft.default, {}),
        mr: 2,
      }),
      children,
    ],
  });
};

TitleWithBackButton.propTypes = {
  /**
   * The basePath
   */
  basePath: _propTypes.default.string.isRequired,

  /**
   * The title, or whatever
   */
  children: _propTypes.default.node.isRequired,
};
var _default = TitleWithBackButton;
exports.default = _default;

//# sourceMappingURL=index.js.map
